import { useQuery } from 'react-query'
import ApiClient from '../lib/api-client'

function fetchCurrentUser () {
  return ApiClient.get('/community/me').then(data => data)
}

function useCurrentUser ({ enabled }) {
  const options = {
    retry: false, // Disable retry to logout immediately
    staleTime: (60 * 1000), // Reduce number of calls to API
    refetchOnWindowFocus: true,
    enabled: Boolean(enabled)
  }
  return useQuery(
    'currentUser',
    () => fetchCurrentUser(),
    options
  )
}

export default useCurrentUser
